import { Link } from "react-router-dom";
import "../../styles/HomeNew.css";
import YGCNav from "../../nav/YGC-Nav";

const SESSIONS = [
  { num: 1, date: "Saturday, July 25th", time: "10:00 AM – 2:00 PM", label: "Kickoff" },
  { num: 2, date: "Saturday, August 1st", time: "10:00 AM – 8:00 PM", label: "Learning Session" },
  { num: 3, date: "Saturday, August 8th", time: "10:00 AM – 8:00 PM", label: "Learning Session" },
  { num: 4, date: "Saturday, August 15th", time: "10:00 AM – 8:00 PM", label: "Learning Session" },
  { num: 5, date: "Saturday, September 26th", time: "10:00 AM – 4:00 PM", label: "Closing Session" },
];

const TOPICS_LEFT = [
  "Self-Awareness Development",
  "Personal Strength Identification",
  "Social Justice",
  "Servant Leadership",
  "Team Building and Collaboration",
];

const TOPICS_RIGHT = [
  "Fundraising Strategies",
  "For a Better Tomorrow Operating Model",
  "Presentation Skills",
  "Values Clarification",
  "Emotional Intelligence",
];

export default function YGCInfo() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "48svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr auto" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Youth Global<br />
              <span className="hero__accent">Citizen</span>
            </h1>
            <p className="hero__sub">
              An experiential leadership program for local high school students that
              develops self-awareness, leadership skills, and an understanding of
              service, philanthropy, and global citizenship.
            </p>
            <div className="hero__pills">
              <span className="pill pill--purple">50+ Program Hours</span>
              <span className="pill pill--pink">High School Students</span>
              <span className="pill pill--green">Summer Program</span>
            </div>
            <div className="hero__ctas">
              <a href="http://tinyurl.com/ygc-app" target="_blank" rel="noopener noreferrer" className="cta cta--solid">
                Apply Now
              </a>
              <a href="http://tinyurl.com/ygc-nom" target="_blank" rel="noopener noreferrer" className="cta cta--ghost">
                Nominate Someone →
              </a>
            </div>
          </div>

          {/* Logo + stats */}
          <div className="hero__stats">
            <div className="hstat hstat--soft" style={{ alignItems: "center" }}>
              <img
                src="/images/ygc/logo.png"
                alt="YGC Logo"
                style={{ maxWidth: 130, maxHeight: 130, objectFit: "contain", display: "block" }}
                onError={e => { e.target.style.display = "none"; }}
              />
            </div>
            <div className="hstat hstat--purple">
              <span className="hstat__n">50+</span>
              <span className="hstat__l">Program Hours</span>
            </div>
            <div className="hstat hstat--pink">
              <span className="hstat__n">5</span>
              <span className="hstat__l">Sessions</span>
            </div>
            <div className="hstat hstat--green">
              <span className="hstat__n">10</span>
              <span className="hstat__l">Topics Covered</span>
            </div>
          </div>
        </div>
      </section>

      {/* ── YGC NAV ── */}
      <div style={{ maxWidth: "var(--max)", marginInline: "auto", padding: "0 var(--pad)" }}>
        <YGCNav />
      </div>

      {/* ── ABOUT ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">About the Program</span>
          <h2 className="sec-h2">What is YGC?</h2>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: ".85rem" }}>
          {[
            "Youth Global Citizen (YGC) is an experiential program for local high school students that develops leadership skills and imparts the significance of service and philanthropy. Participants develop self-awareness, leadership skills, and learn about diversity, poverty, values, and socioeconomic disparities in our community and in our world. By the end of the program, participants will have invested over fifty hours in program activities and information sessions.",
            "However, YGC entails much more than leadership training; it also provides participants with an opportunity to use their newfound skills and awareness to help others and in so doing make a positive contribution to their community and their world.",
            "We ask all program participants to fully commit to the sessions. If you are unable to attend all the program sessions in person, please consider applying for the program next year. Besides the learning events, please be prepared to spend at least two additional hours a week in August and September to complete your project assignment.",
          ].map((text, i) => (
            <div key={i} className="lcard" style={{ flexDirection: "row", gap: "1rem", alignItems: "flex-start" }}>
              <span style={{
                flexShrink: 0, width: 10, height: 10, borderRadius: "50%", marginTop: ".55rem",
                background: i === 0 ? "var(--pu-500)" : i === 1 ? "var(--pk-500)" : "var(--gn-500)",
                boxShadow: `0 0 6px ${i === 0 ? "var(--pu-200)" : i === 1 ? "var(--pk-200)" : "var(--gn-200)"}`,
              }} />
              <p style={{ fontSize: ".93rem", color: "var(--muted)", lineHeight: 1.8 }}>{text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* ── SESSIONS ── */}
      <section className="local" style={{ background: "var(--off)", maxWidth: "100%", paddingInline: "var(--pad)" }}>
        <div style={{ maxWidth: "860px", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">Schedule</span>
            <h2 className="sec-h2">Learning Sessions</h2>
            <p className="sec-sub">The YGC program covers a wide range of topics facilitated by community members with deep knowledge and expertise.</p>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: ".75rem" }}>
            {SESSIONS.map((s, i) => {
              const colors = [
                { bg: "var(--pu-50)", bd: "var(--pu-200)", chip: "lchip--purple", num: "var(--pu-700)" },
                { bg: "var(--pk-50)", bd: "var(--pk-200)", chip: "lchip--pink", num: "var(--pk-700)" },
                { bg: "var(--gn-50)", bd: "var(--gn-200)", chip: "lchip--green", num: "var(--gn-700)" },
              ];
              const col = colors[i % 3];
              return (
                <div key={i} className="lcard" style={{
                  background: col.bg, borderColor: col.bd,
                  flexDirection: "row", gap: "1.1rem", alignItems: "center",
                }}>
                  <div style={{
                    flexShrink: 0, width: 40, height: 40, borderRadius: "50%",
                    background: col.bd, display: "flex", alignItems: "center", justifyContent: "center",
                    fontFamily: "var(--ff-head)", fontWeight: 800, fontSize: "1rem", color: col.num,
                  }}>
                    {s.num}
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: ".5rem", marginBottom: ".2rem" }}>
                      <h3 style={{ fontFamily: "var(--ff-head)", fontSize: ".97rem", fontWeight: 800, color: "var(--ink)" }}>
                        {s.date}
                      </h3>
                      <span className={`lcard__chip ${col.chip}`} style={{ fontSize: ".6rem" }}>{s.label}</span>
                    </div>
                    <p style={{ fontSize: ".84rem", color: "var(--muted)" }}>{s.time}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* ── TOPICS ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Curriculum</span>
          <h2 className="sec-h2">Learning Session Topics</h2>
          <p className="sec-sub">Learning session topics addressed in YGC may include:</p>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: ".65rem" }}>
          {[...TOPICS_LEFT, ...TOPICS_RIGHT].map((topic, i) => (
            <div key={i} className="lcard" style={{
              flexDirection: "row", gap: ".75rem", alignItems: "center", padding: ".85rem 1rem",
            }}>
              <span style={{
                flexShrink: 0, width: 8, height: 8, borderRadius: "50%",
                background: i % 3 === 0 ? "var(--pu-500)" : i % 3 === 1 ? "var(--pk-500)" : "var(--gn-500)",
              }} />
              <p style={{ fontSize: ".87rem", color: "var(--muted)", lineHeight: 1.5 }}>{topic}</p>
            </div>
          ))}
        </div>
        <div style={{ marginTop: "1.25rem" }}>
          <a
            href="https://docs.google.com/document/d/10si-3x2quUG_PT_Ppa_HlaUJcNVAvY86asyzwmrNayU/edit#heading=h.6jynaot9cbnq"
            target="_blank"
            rel="noopener noreferrer"
            className="lcard__toggle"
            style={{ textDecoration: "none", display: "inline-block" }}
          >
            Click here for additional program information ↗
          </a>
        </div>
      </section>

      {/* ── PROJECT OVERVIEW ── */}
      <section className="local" style={{ background: "var(--off)", maxWidth: "100%", paddingInline: "var(--pad)" }}>
        <div style={{ maxWidth: "860px", marginInline: "auto" }}>
          <div className="sec-hd">
            <span className="sec-eye">Action Component</span>
            <h2 className="sec-h2">Project Overview</h2>
          </div>
          <div className="lcard lcard--open" style={{ padding: "1.8rem 2rem" }}>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.85 }}>
              Participants work actively to support a local non-profit organization, and this active
              involvement allows participants to put their developing leadership skills to immediate use.
              By pairing learning with action, YGC ensures that participants are knowledgeable about how
              they can become engaged citizens and equips participants to do so through hands-on experience
              in the program.
            </p>
          </div>
        </div>
      </section>

      {/* ── CTA CARDS ── */}
      <section className="events" style={{ maxWidth: "700px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Get Involved</span>
          <h2 className="sec-h2">Ready to Join?</h2>
        </div>
        <div className="events__grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
          <a href="http://tinyurl.com/ygc-app" target="_blank" rel="noopener noreferrer" className="ecard card--purple">
            <div className="ecard__icon">📝</div>
            <div className="ecard__img" style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "var(--pu-200)", fontSize: "4rem",
            }}>
              ✋
            </div>
            <span className="ecard__label">Apply</span>
            <h3 className="ecard__name">Interested?</h3>
            <p className="ecard__desc">Let us know with this quick interest form and take the first step toward joining YGC.</p>
            <span className="ecard__arrow">Apply now →</span>
          </a>

          <a href="http://tinyurl.com/ygc-nom" target="_blank" rel="noopener noreferrer" className="ecard card--green">
            <div className="ecard__icon">🌟</div>
            <div className="ecard__img" style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "var(--gn-200)", fontSize: "4rem",
            }}>
              👥
            </div>
            <span className="ecard__label">Nominations</span>
            <h3 className="ecard__name">Know Someone?</h3>
            <p className="ecard__desc">Share your recommendations and help us find the next generation of servant leaders.</p>
            <span className="ecard__arrow">Nominate →</span>
          </a>
        </div>
      </section>

      {/* ── FLYER ── */}
      <section className="local" style={{ maxWidth: "680px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Event Flyer</span>
          <h2 className="sec-h2">YGC 2026</h2>
        </div>
        <div className="lcard lcard--open" style={{ padding: "1.5rem", alignItems: "center" }}>
          <img
            src="/images/flyers/YGC26.jpg"
            alt="YGC 2026 Flyer"
            style={{ width: "100%", borderRadius: "12px", display: "block", boxShadow: "0 8px 40px rgba(0,0,0,.1)" }}
          />
        </div>
      </section>

      {/* ── QUOTE BAND ── */}
      <div className="quote-band">
        <p>"Developing the next generation of servant leaders — one community at a time."</p>
      </div>

    </div>
  );
}